import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface IStaffInfo {
  name?: string;
  title?: string;
  subTitle?: string;
  url?: string;
  email?: string;
  address1?: string;
  address2?: string;
  number?: string;
}

export const StaffInformation: IStaffInfo[] = [
  {
    name: 'Julian Canete',
    subTitle: 'President and CEO',
    email: 'canetej@cahcc.com',
    url: 'mailto:canetej@cahcc.com',
  },

  {
    name: 'Oscar Garcia',
    title: 'CAHCC Senior Vice President',
    subTitle: 'SBDC Director',
    email: 'oscar@cahcc.com',
    url: 'mailto:oscar@cahcc.com',
  },
  {
    name: 'Edith Gomez',
    title: 'CAHCC Associate Vice President',
    subTitle: 'SBDC Assistant Director',
    email: 'edith@cahcc.com',
    url: 'mailto:edith@cahcc.com',
  },
  {
    name: 'Laura Cabanero',
    subTitle: 'Office Manager',
    email: 'Laura@cahcc.com',
    url: 'mailto:Laura@cahcc.com',
  },
  {
    name: 'Luis Lopez',
    subTitle: 'Assistant Deputy Chief of Staff',
    email: 'luis@cahcc.com',
    url: 'mailto:luis@cahcc.com',
  },
  {
    name: 'Gema Gonzalez',
    subTitle: 'Marketing & Community Outreach Coordinator',
    email: 'gema@cahcc.com',
    url: 'mailto:gema@cahcc.com',
  },
  {
    name: 'Joel Santiago',
    subTitle: 'Special Project Coordinator',
    email: 'joel.santiago@cahcc.com',
    url: 'mailto:joel.santiago@cahcc.com',
  },
  {
    name: 'Magali Torres',
    subTitle: 'Executive Assistant',
    email: 'magali@cahcc.com',
    url: 'mailto:magali@cahcc.com',
  },
];
export const ContactInfo: IStaffInfo[] = [
  {
    name: 'CHCC Office Address',
    address1: '1510 J Street, Suite 210',
    address2: 'Sacramento, CA 95814',
    number: '916.444.2221',
    url: 'mailto:info@cahcc.com',
    subTitle: '',
    email: 'info@cahcc.com',
  },
];
@Component({
    selector: 'app-staff',
    templateUrl: './staff.component.html',
    styleUrls: ['./staff.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaffComponent implements OnInit {
  mainTitle = 'CHCC Staff';
  staffs: any = [];
  infos: any = [];

  constructor() {}

  ngOnInit(): void {
    this.staffs = StaffInformation.filter((staff) => staff);
    this.infos = ContactInfo.filter((info) => info);
  }
}
